import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import FormatUrl from "../../utils/UrlFormatter";
import StandardModal from '../Modals/standardModal';
import './staffManage.css';

const AddAdminOwner = ({ clinicId, onSuccess }) => {
  const { t } = useTranslation();

  const [firstName, setFirstName] = useState('');
  const [middleName, setMiddleName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [role, setRole] = useState('CA');
  const [errors, setErrors] = useState({});

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalMessage, setModalMessage] = useState('');

  const closeModal = () => {
    setIsModalVisible(false);
    setModalMessage('');
    setModalTitle('');
    if (modalTitle === 'Success') {
      onSuccess();
    }
  };

  const resetFormFields = () => {
    setFirstName('');
    setMiddleName('');
    setLastName('');
    setEmail('');
    setPhone('');
    setRole('CA');
    setErrors({});
  };

  const validate = () => {
    let valid = true;
    const newErrors = {};

    if (!firstName.trim()) {
      newErrors.firstName = t("staff-add-admin-validation.first_name_required");
      valid = false;
    }
    if (!lastName.trim()) {
      newErrors.lastName = t("staff-add-admin-validation.last_name_required");
      valid = false;
    }
    if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = t("staff-add-admin-validation.valid_email_required");
      valid = false;
    }
    if (!phone.trim() || !/^\d{10}$/.test(phone)) {
      newErrors.phone = t("staff-add-admin-validation.valid_phone_required");
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const csrfUrl = FormatUrl(`/csrf-token/`);
      const csrfResponse = await fetch(csrfUrl, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include'
      });

      if (!csrfResponse.ok) throw new Error('Failed to fetch CSRF token');

      const csrfData = await csrfResponse.json();
      const csrfToken = csrfData.csrfToken;

      const formData = new URLSearchParams();
      formData.append('firstName', firstName);
      formData.append('middleName', middleName);
      formData.append('lastName', lastName);
      formData.append('email', email);
      formData.append('phone', `+1${phone}`);
      formData.append('role', role);
      formData.append('clinic_id', clinicId);

      const apiUrl = FormatUrl('/add-clinic-admin-owner/');
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRFToken': csrfToken
        },
        body: formData,
        credentials: 'include'
      });

      if (!response.ok) throw new Error('Failed to add admin/owner');

      setModalTitle(t("staff_add_admin.modal_success"));
      setModalMessage(
        role === 'CO'
          ? t("staff_add_admin.owner_added_successfully")
          : t("staff_add_admin.admin_added_successfully")
      );
      setIsModalVisible(true);
      resetFormFields();
    } catch (error) {
      console.error("Error during admin/owner addition:", error);
      setModalTitle(t("staff_add_admin.modal_error"));
      setModalMessage(t("staff_add_admin.modal_error_message"));
      setIsModalVisible(true);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <h3 className="add-practitioner-title">{t("staff_add_admin.title_owner_admin")}</h3>
        <div className="mandatory-fields-banner">
          <p>{t("staff_add_admin.note_one")} <span className="mandatory">*</span> {t("staff_add_admin.note_one")}.</p>
        </div>

        <div className="name-fields">
          <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder={t("staff_add_admin.first_name")} required />
          {errors.firstName && <p className="error">{errors.firstName}</p>}

          <input type="text" value={middleName} onChange={(e) => setMiddleName(e.target.value)} placeholder={t("staff_add_admin.middle_name")} />

          <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder={t("staff_add_admin.last_name")} required />
          {errors.lastName && <p className="error">{errors.lastName}</p>}
        </div>

        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("staff_add_admin.prac_email")} required />
        {errors.email && <p className="error">{errors.email}</p>}

        <input type="text" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder={t("staff_add_admin.prac_phone")} required />
        {errors.phone && <p className="error">{errors.phone}</p>}

        <div className="dropdown-container">
          <select value={role} onChange={(e) => setRole(e.target.value)} required>
            <option value="CO">{t("staff_add_admin.role_owner")}</option>
            <option value="CA">{t("staff_add_admin.role_admin")}</option>
          </select>
        </div>

        <div className="button-container">
          <button type="submit" className="add-practitioner-btn">{t("staff_add_admin.add_prac")}</button>
          <button type="button" className="cancel-practitioner-btn" onClick={resetFormFields}>{t("staff_add_admin.cancel")}</button>
        </div>
      </form>

      <StandardModal
        isOpen={isModalVisible}
        onClose={closeModal}
        title={modalTitle}
        message={modalMessage}
      />
    </>
  );
};

export default AddAdminOwner;
